import urlBuilder from "~/assets/js/urlBuilder";

export default (api) => ({
  // CRUD principal
  fetch: (params) => api.$get(urlBuilder("/vaccines", params)),

  fetchOne: (id) => api.$get(`/vaccines/${id}`),

  create: (body) => api.$post("/vaccines", body),

  patch: (id, body) => api.$patch(`/vaccines/${id}`, body),

  remove: (id) => api.$delete(`/vaccines/${id}`),

  fetchAll: () => api.$get("/vaccines/all"),

  // Metadata
  fetchTypes: () => api.$get("/vaccines/types"),

  fetchCategories: () => api.$get("/vaccines/categories"),

  fetchOses: () => api.$get("/oses"),

  fetchDqlFields: () => api.$get("/vaccines/dql/fields"),

  // Búsqueda DQL
  searchDql: (params, filters) => api.$post(urlBuilder("/vaccines/search", params), filters),

  searchDqlByAgency: (agencyId, params, filters) =>
    api.$post(urlBuilder(`/agencies/${agencyId}/vaccines/search`, params), filters),

  // Contexto agencia
  fetchByAgency: (agencyId, params) =>
    api.$get(urlBuilder(`/agencies/${agencyId}/vaccines`, params)),

  // Deployments
  fetchDeployments: (vaccineId, params) =>
    api.$get(urlBuilder(`/vaccines/${vaccineId}/deployments`, params)),

  fetchAgencyDeployments: (agencyId, vaccineId, params) =>
    api.$get(urlBuilder(`/agencies/${agencyId}/vaccines/${vaccineId}/deployments`, params)),

  // Ejecución - agencias
  applyToAgency: (vaccineId, agencyId) =>
    api.$put(`/vaccines/${vaccineId}/agencies/${agencyId}/apply`, [agencyId]),

  stopFromAgency: (vaccineId, agencyId) =>
    api.$put(`/vaccines/${vaccineId}/agencies/${agencyId}/stop`, [agencyId]),

  // Ejecución - agentes
  applyToAgent: (vaccineId, agentId) =>
    api.$put(`/vaccines/${vaccineId}/agents/${agentId}/apply`, [agentId]),

  stopFromAgent: (vaccineId, agentId) =>
    api.$put(`/vaccines/${vaccineId}/agents/${agentId}/stop`, [agentId]),

  // Ejecución - usuario (todas sus agencias)
  applyToUserAgencies: (vaccineId) => api.$put(`/vaccines/${vaccineId}/applyToUserAgencies`),

  stopFromUserAgencies: (vaccineId) => api.$put(`/vaccines/${vaccineId}/stopFromUserAgencies`),

  // Import/Export
  exportZip: () => api.$get("/vaccine/export", { responseType: "blob" }),

  importZip: (formData) => api.$post("/vaccines/uploadzip", formData),
});
